import React, { Component } from 'react';
import { DialogTitle} from '@material-ui/core';
import './loading.scss';
import styled from'styled-components'
import i18n from '../../i18n';
class loading extends Component {
    render() {
        const Vimoneloding = styled.img`
        z-index : 99;
        width: 100px;
        position: relative;
        top : 35%;
        left: 3px;
        transition : all .5s ease;
        `
        const LoadingWrap = styled.div`
            width : 100%;
            height : 650px;
            position: relative;
            text-align : center;
            margin :auto;
        `
        const Container = styled.div`
            position : relative;
            top: 45%;
        `
        const LoadingText = styled.div`
            color : ${({reversal})=>reversal?'white':'black'};
            flex: 2;
            padding-top: 5px;
            padding-left: 5px;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: -5px;
        `
        const FlexloadingText = styled.div`
            display :flex;
            justify-content: center;
            align-items: center;
            width : 350px;
            margin : auto;
            flex-direction : column;
        `
        return (
            <LoadingWrap>
                <Container>
                    <FlexloadingText>
                        <LoadingText reversal={this.props.reversal}>{this.props.componentName}</LoadingText>
                        <LoadingText reversal={this.props.reversal}>{this.props.enableLoadingText ? i18n.t("loading.text") : null}</LoadingText>
                        <div id="lds-ellipsis-loading" className={(this.props.reversal?"reversal ":"")}><div></div><div></div><div></div><div></div></div>
                    </FlexloadingText>
                </Container>
            </LoadingWrap>
        );
    }
}

export default loading;